<template>
	<div id="theHeader" class="flex">
		<div @click="tutorial">
			<font-awesome-icon :icon="['fal', 'question-circle']" />
		</div>
		<div class="logo"></div>
		<div @click="switchPage('Userinfo')">
			<font-awesome-icon :icon="['fal', 'user']" />
		</div>
	</div>
</template>
<script>
export default {
	name: 'theHeader',
	methods: {
		async logout () {
			const message = 'ログアウトしますか？'
			if (window.confirm(message)) {
				await this.$auth.logout({
					returnTo: window.location.origin
				})
			}
		},
		tutorial () {
			this.$emit('showModalSlidesComponent')
		},
		switchPage (target) {
			const { name } = this.$route
			if (target === name) return
			this.$router.push({ name: target })
		}
	}
}
</script>

<style lang="stylus" scoped>
@import "~@/themes/styles/mixins.styl"

#theHeader
	background-color main-color
	flex-direction row
	justify-content space-between
	height 60px
	line-height 60px
	border-bottom 1px solid main-color
	padding 0 18px
	font-size 1.3rem
	.logo
		height 60px
		background-image url(../assets/logo_nexto_store.png)
		background-repeat no-repeat
		margin 0 20%
		flex 1
		background-size contain
		background-position center
		max-width 200px
	svg
		color text-deep
</style>
